import axiosInstance from "../api/apiClient";


const adminService = {
  getAllUsers: async () => {
    const res = await axiosInstance.get(`/admin/users`);
    return res.data;
  },

  approveUser: async (id) => {
    const res = await axiosInstance.put(`/admin/approve/${id}`);
    return res.data;
  },

  denyUser: async (id) => {
    const res = await axiosInstance.put(`/admin/deny/${id}`); //user/:id
    return res.data;
  },

  deleteUser: async (id) => {
    const res = await axiosInstance.delete(`/admin/user/${id}`); //
    return res.data;
  },
};

export default adminService;
